export const MOBILE_BREAKPOINT = 768;
export const CHANGE_TYPES: Record<string, string> = {
  CHANGE_ADDRESS: 'Change Address',
  CHANGE_LIMIT: 'Change Limit',
  UPDATE_PAYROLL: 'Update Payroll',
  OTHER: 'Other',
};
